import React from "react";
import PropTypes from "prop-types";

function Edit({
  className,
  style,
  fill,
  backgroundColor,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path fill={backgroundColor} d="M-739-382H701V642H-739z" />
        <path
          d="M14.248 1.731a3.171 3.171 0 00-4.488 0L1.53 9.958a.412.412 0 00-.116.236l-.61 4.516a.41.41 0 00.116.346.419.419 0 00.292.123c.018 0 .036 0 .055-.003l2.72-.368a.414.414 0 10-.11-.821l-2.181.294.425-3.15 3.316 3.315a.406.406 0 00.582 0l8.23-8.226c.6-.6.93-1.397.93-2.246 0-.848-.33-1.645-.93-2.243zm-4.33 1.012l1.383 1.381-7.51 7.51-1.382-1.382 7.51-7.51zM5.732 13.57L4.38 12.22l7.509-7.51 1.351 1.352-7.51 7.51zm8.085-8.1L10.51 2.162a2.34 2.34 0 011.495-.536 2.341 2.341 0 012.347 2.347c0 .555-.19 1.076-.536 1.495z"
          fill-rule="nonzero"
          fill={fill}
        />
      </g>
    </svg>
  );
}

Edit.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

Edit.defaultProps = {
  className: undefined,
  defaultHeight: 16,
  defaultWidth: 16,
  fill: "#D2E3E4",
  backgroundColor: "none"
};

export default Edit;
